#import "../fragments/webcast-fragment.graphql"

mutation RegisterForWebcast($registrationInput: DemioRegisterInputFieldInput!) {
    demioRegister(input: {registration: $registrationInput}) {
        webcast {
            ...Webcast
        }
    }
}
